import PreviewCertificateTemplate from './PreviewCertificateTemplate'

export default PreviewCertificateTemplate
